export interface ExperimentActivationParams {
  testName: string
  testVariation: string
}

export const trackExperimentActivation =
  ({ testName, testVariation }: ExperimentActivationParams) =>
  () => {
    const event = {
      event: 'experiment_activation',
      experiment_name: testName,
      experiment_variant: testVariation,
    }

    return event
  }
